import { render } from "./AnnotatedTextWidget.vue?vue&type=template&id=cf51320c&scoped=true"
import script from "./AnnotatedTextWidget.vue?vue&type=script&lang=js"
export * from "./AnnotatedTextWidget.vue?vue&type=script&lang=js"

import "./AnnotatedTextWidget.vue?vue&type=style&index=0&id=cf51320c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf51320c"]])

export default __exports__